export const media_types = [
  { key: 'apps', text: 'Apps', value: 'Apps' },
  { key: 'audio-books', text: 'Audio Books', value: 'Audio Books' },
  { key: 'audio-lessons', text: 'Audio Lessons', value: 'Audio Lessons' },
  { key: 'books', text: 'Books', value: 'Books' },
  {
    key: 'chrome-extension',
    text: 'Chrome Extension',
    value: 'Chrome Extension',
  },
  { key: 'dictionary', text: 'Dictionary', value: 'Dictionary' },
  {
    key: 'exam-preparation',
    text: 'Exam Preparation',
    value: 'Exam Preparation',
  },
  { key: 'facebook-group', text: 'Facebook Group', value: 'Facebook Group' },
  { key: 'grammar', text: 'Grammar', value: 'Grammar' },
  {
    key: 'inperson-course',
    text: 'In Person Course',
    value: 'In Person Course',
  },
  { key: 'language-groups', text: 'Language Groups', value: 'Language Groups' },
  {
    key: 'language-learning-blog',
    text: 'Language Learning Blog',
    value: 'Language Learning Blog',
  },
  { key: 'magazine', text: 'Magazine', value: 'Magazine' },
  { key: 'memrise-course', text: 'Memrise Course', value: 'Memrise Course' },
  { key: 'online-game', text: 'Online Game', value: 'Online Game' },
  { key: 'online-tutoring', text: 'Online Tutoring', value: 'Online Tutoring' },
  { key: 'online-course', text: 'Online Course', value: 'Online Course' },
  { key: 'podcast', text: 'Podcast', value: 'Podcast' },
  {
    key: 'pronunciation-guide',
    text: 'Pronunciation Guide',
    value: 'Pronunciation Guide',
  },
  {
    key: 'spaced-repetition',
    text: 'Spaced Repetition',
    value: 'Spaced Repetition',
  },
  {
    key: 'text-based-lessons',
    text: 'Text Based Lessons',
    value: 'Text Based Lessons',
  },
  { key: 'video-lessons', text: 'Video', value: 'Video' },
  {
    key: 'vocabulary-builder',
    text: 'Vocabulary Builder',
    value: 'Vocabulary Builder',
  },
  { key: 'youtube-channel', text: 'YouTube Channel', value: 'YouTube Channel' },
];
